import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CreateDeviceDialogComponent } from 'app/dialogs/create-device-dialog/create-device-dialog.component';
import { UpdateDeviceDialogComponent } from 'app/dialogs/update-device-dialog/update-device-dialog.component';
import { DeviceService } from 'app/services/models/device.service';

@Component({
  selector: 'app-reference-device-list',
  templateUrl: './reference-device-list.component.html',
  styleUrls: ['./reference-device-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReferenceDeviceListComponent implements OnInit {
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  public searchValue = '';
  totalCount: number = 0;
  public ColumnMode = ColumnMode;

  constructor(
    private deviceService: DeviceService,
    private modalService: NgbModal,
    private router:Router) { }

  async ngOnInit() {
    await this.getAllReferenceDevice(this.pageBasic - 1, this.selectedSize, this.searchValue);
    this.deviceService.event$.subscribe(async result => {
      await this.getAllReferenceDevice(this.pageBasic - 1, this.selectedSize, this.searchValue);
    })
  }

  onActivate(event){
    if (event.type === 'click' && event.row) {
      this.router.navigate([`/admin/device-reference/${event.row.id}`]);
    }
  }

  createDevice() {
    const modal = this.modalService.open(CreateDeviceDialogComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      id: null,
      companyId: 1,
      isReferenceDevice:true
    }
  }

  updateDevice(id, event) {
      event.stopPropagation();
      const modal = this.modalService.open(UpdateDeviceDialogComponent, {
        size: 'lg',
        windowClass: 'modal modal-success'
      });
      modal.componentInstance.data = {
        id: id,
        isReferenceDevice:true
      }
    }

  async getAllReferenceDevice(page, size, search) {
    const data = await this.deviceService.getAllDevices(page, size, search, 1);
    console.log(data);
    this.rows = data.devices;
    this.totalCount = data.totalCount;
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {
      await this.getAllReferenceDevice(this.pageBasic - 1, this.selectedSize, this.searchValue);
    }, 500);
  }

  async onPageChange() {
    await this.getAllReferenceDevice(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }
}
